var _rect, _g, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOsif(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1240 1240",
    width: 1240,
    height: 1240,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1240,
    height: 1240,
    rx: 238,
    ry: 238,
    fill: "#FFFFFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#28A828",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M470 425 L 700 623 L 470 821",
    strokeWidth: 128
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655 285 L 1020 623 L 655 962",
    strokeWidth: 146
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 623,
    r: 70,
    fill: "#28A828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOsif);
export default __webpack_public_path__ + "static/media/osif.2141aaed52577eadd24fa4dbcec3b097.svg";
export { ForwardRef as ReactComponent };